import { useFeatureValue as gbUseFeatureValue } from '@growthbook/growthbook-react';
import type { FeatureMap } from './helpers';

export const useFeatureValue = <K extends keyof ExcludeKeysOfType<FeatureMap, boolean>>(
  flag: K,
  defaultValue?: ExcludeKeysOfType<FeatureMap, boolean>[K],
) => {
  const value = gbUseFeatureValue(flag, defaultValue ?? null);

  return { value };
};
